export const hubMessages = {
  quickTransfer: ['Быстрый перевод', 'Quick transfer', 'Sürətli köçürmə'],
  bonusDay: ['День {{day}}', 'Day {{day}}', 'Gün {{day}}'],
  videoCall: ['Видеозвонок', 'Video call', 'Video zəng'],
  chatActions: ['Действия с чатом', 'Chat actions', 'Çat əməliyyatları'],
  worldSubtitle: [
    'Всё, что связывает вас с городом',
    'Everything that connects you to your city',
    'Sizi şəhərə bağlayan hər şey',
  ],
  marketHint: ['Товары и услуги', 'Products and services', 'Məhsullar və xidmətlər'],
  eventsHint: [
    'Встречи и впечатления',
    'Meetups and experiences',
    'Görüşlər və təəssüratlar',
  ],
  partnersHint: ['Места и предложения', 'Places and offers', 'Məkanlar və təkliflər'],
  mapHint: [
    'Люди и места рядом',
    'People and places nearby',
    'Yaxındakı insanlar və məkanlar',
  ],
  reorderHint: [
    'Перетаскивайте блоки за ручку, чтобы менять порядок',
    'Drag widgets by their handles to reorder',
    'Sıralamaq üçün vidcetləri tutacaqlarından sürükləyin',
  ],
  reorderKeyboard: [
    'Пробел — взять блок, стрелки — выбрать место, Enter — переместить, Escape — отменить.',
    'Space to pick up, arrows to choose a position, Enter to drop, Escape to cancel.',
    'Seçmək üçün boşluq, mövqe üçün oxlar, yerləşdirmək üçün Enter, ləğv üçün Escape.',
  ],
  reorderWidget: ['Переместить: {{name}}', 'Move: {{name}}', 'Yerini dəyiş: {{name}}'],
  reorderTarget: [
    '{{name}}: новое место — {{position}}',
    '{{name}}: new position {{position}}',
    '{{name}}: yeni mövqe {{position}}',
  ],
  reorderSaved: [
    'Порядок блоков сохранён',
    'Widget order saved',
    'Vidcet sırası saxlanıldı',
  ],
  widgetVisibility: ['Какие блоки показывать', 'Visible widgets', 'Görünən vidcetlər'],
  widgetVisibilityHint: [
    'Оставьте нужное. Порядок можно изменить и здесь, и на главной странице «Мира».',
    'Keep what matters. Reorder here or on the World page.',
    'Lazım olanları saxlayın. Burada və Dünya səhifəsində sıralayın.',
  ],
  hubDisplay: ['Отображение', 'Display', 'Görünüş'],
  hubEmpty: ['Соберите свой «Мир»', 'Make World your own', 'Dünyanızı qurun'],
  hubEmptyHint: [
    'Добавьте записи, покупки и другие важные для вас блоки.',
    'Add appointments, purchases and the widgets you need.',
    'Rezervasiyaları, alışları və lazım olan vidcetləri əlavə edin.',
  ],
  emptyBookings: [
    'Здесь появится ваша ближайшая запись',
    'Your next appointment will appear here',
    'Növbəti rezervasiyanız burada görünəcək',
  ],
  emptyPurchases: [
    'Здесь будут ваши активные покупки',
    'Your active purchases will appear here',
    'Aktiv alışlarınız burada görünəcək',
  ],
  emptyFavorites: [
    'Сохраняйте товары и услуги, которые понравились',
    'Save the products and services you like',
    'Bəyəndiyiniz məhsul və xidmətləri saxlayın',
  ],
  emptyCalendar: [
    'Новые записи клиентов появятся здесь',
    'New client appointments will appear here',
    'Yeni müştəri rezervasiyaları burada görünəcək',
  ],
  emptySales: [
    'Активные продажи будут под рукой',
    'Keep your active sales close at hand',
    'Aktiv satışlarınız əlinizin altında olsun',
  ],
  world: ['Мир', 'World', 'Dünya'],
  myBlocks: ['Мои блоки', 'My widgets', 'Vidcetlərim'],
  configure: ['Настроить', 'Customize', 'Fərdiləşdir'],
  personal: ['Личное', 'Personal', 'Şəxsi'],
  business: ['Мои дела', 'My business', 'İşlərim'],
  market: ['Маркет', 'Market', 'Market'],
  account: ['Кабинет', 'My account', 'Kabinet'],
  products: ['Товары', 'Products', 'Məhsullar'],
  events: ['События', 'Events', 'Tədbirlər'],
  partners: ['Партнёры', 'Partners', 'Tərəfdaşlar'],
  listings: ['Объявления', 'Listings', 'Elanlar'],
  hubSettings: ['Настройки «Мира»', 'World settings', 'Dünya ayarları'],
  layout: ['Раскладка', 'Layout', 'Görünüş'],
  tabsLayout: ['Вкладки', 'Tabs', 'Vərəqlər'],
  unifiedLayout: ['Единая лента', 'One feed', 'Vahid lent'],
  hideAmounts: [
    'Скрывать суммы кошелька',
    'Hide wallet amounts',
    'Pul kisəsi məbləğlərini gizlət',
  ],
  widgetPulse: ['Пульс города', 'City pulse', 'Şəhərin nəbzi'],
  widgetBookings: ['Мои записи', 'My appointments', 'Rezervasiyalarım'],
  widgetPurchases: ['Мои покупки', 'My purchases', 'Alışlarım'],
  widgetFavorites: ['Избранное', 'Favorites', 'Seçilmişlər'],
  widgetWallet: ['Кошелёк', 'Wallet', 'Pul kisəsi'],
  widgetChats: ['На связи', 'In touch', 'Əlaqədə'],
  widgetFriends: ['Друзья рядом', 'Friends nearby', 'Yaxındakı dostlar'],
  widgetCalendar: ['Календарь мастера', 'Professional calendar', 'Mütəxəssis təqvimi'],
  widgetListings: ['Мои объявления', 'My listings', 'Elanlarım'],
  widgetSales: ['Мои продажи', 'My sales', 'Satışlarım'],
  updateFailed: [
    'Не удалось обновить блок',
    'Could not refresh this widget',
    'Vidceti yeniləmək alınmadı',
  ],
  moveUp: ['Выше', 'Move up', 'Yuxarı'],
  moveDown: ['Ниже', 'Move down', 'Aşağı'],
  createContent: ['Публикация или история', 'Post or story', 'Paylaşım və ya hekayə'],
  sellProduct: ['Продать товар', 'Sell a product', 'Məhsul sat'],
  offerService: ['Предложить услугу', 'Offer a service', 'Xidmət təklif et'],
} as const;
